import groq from "groq"

import { AppSettings } from "@/settings"

import { visitReportOccasionProjection } from "../sanity/visitReportsOccasion.projection"

export const queryVisitReportsOccasions = {
  async visitReportsOccasions(parent, args, context, info) {
    const lang = AppSettings.defaultLocale()
    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: (args.cdn = false) })

    try {
      const occasions = await client.fetch(groq`*[_type=="occasion"]{
        ${visitReportOccasionProjection()}
      }`)
      return occasions
    } catch (error) {
      console.warn(error)
      throw new Error("Failed to fetch visit report occasions")
    }
  },
}
